import View from './LiveVideo'
import { connect } from 'react-redux'
import { guessLiveVideoStreamId } from '../../../utilities/media/videos'

const mapStateToProps = state => ({
  locale: state.router.locale,
  id: guessLiveVideoStreamId(state.router.locale),
})

const LiveVideo = connect(mapStateToProps)(View)

export default LiveVideo
